import React, {useContext, useEffect, useState} from 'react';
import { useMediaQuery } from 'react-responsive'

import Markup from '../../../../markup';
import Toggle from '../../../Global/Toggle';
import Count from '../../../Global/Count';
import { device } from '../../../../const/device';
import BuilderContext from '../../../../builder/hooks/context';
import {SaveButtons} from "../SaveButtons";
import Tooltip from "../../../Global/Tooltip";
import Warning from '../../../Global/Warning';
import { trackAddToCart, trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';
import { models } from '../../../../const/models';

function NameSpec() {
    const { builder } = useContext(BuilderContext);
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });
    const isMobile = useMediaQuery({ query: `(${device.mobileL})` });
    
    const [showSizeWarning, setShowSizeWarning] = useState<boolean>(false);

    const currentMemberSize = builder.membersData.members[builder.membersData.currentMemberIndex].data.size;

    useEffect(() => {
        if (currentMemberSize !== "") {
            setShowSizeWarning(false);
        }
    }, [currentMemberSize]);

    useEffect(() => {
        trackSubStage('Specs', 'Specs');
        trackBeforeUnload('Specs');
    }, []);

    const handleAddToCart = () => {
        if (currentMemberSize === "") {
            setShowSizeWarning(true);
            return;
        }

        const memberData = builder.membersData.members[builder.membersData.currentMemberIndex].data;

        const size = memberData?.size;
        const sleeve = memberData?.sleeve;
        const gender = memberData?.sex;
        const quantity = memberData?.quantity;

        const productType = models.find(model => model.manifest === builder.manifestURL)?.product;
        const pattern = builder.modelData?.pattern;

        const hasBridgeFunctions =
          typeof (window as any).builderSaveDesign === 'function' &&
          typeof (window as any).builderAddToCartBatch === 'function';

        if (hasBridgeFunctions) {
            // Batch flow — don't submit per member. Just mark as "ready" (green checkmark).
            // Actual cart submission happens when "GO TO CART" is clicked.
            builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart = true;
        } else {
            // Legacy per-member submission
            builder.updateAddCart(true);
        }

        trackAddToCart(gender, size, productType, sleeve, quantity, pattern);
    };

    return (
        <>
            <Markup.Screen.Name.SpecContainer>
                <Markup.Screen.Name.DisableOverlaySpec themeColor={builder.membersData.colorTheme} disOverSpec={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}/>
                {!isMobile &&
                    <>
                        {builder.modelData.surffaceList.length === 0 &&
                            <Markup.Screen.Name.SpecItemSize>
                                {builder.modelData.surffaceList.length !== 0 &&
                                    <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>Select
                                    Size{builder.manifest.notification['Spec'] ?
                                        <Tooltip Icon={Markup.Global.Link.LinkHelpIcon} width={isTablet ? 320 : 366}
                                                 offset={isTablet ? -190 : -100} bottom>
                                            <Markup.Screen.Color.HelpTextContainer>
                                                {builder.manifest.notification['Notice-Spec']}
                                            </Markup.Screen.Color.HelpTextContainer>
                                        </Tooltip> : ''}
                                </Markup.Screen.Name.SpecItemText>}
                                {!builder.surffaceList &&
                                   <Toggle 
                                    active={currentMemberSize}
                                    setActive={item => {
                                        builder.membersData.updateMember({ data: { size: item } });
                                    }}
                                    items={[...builder?.options?.size].sort((a, b) => {
                                        const order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
                                        return order.indexOf(a.toUpperCase()) - order.indexOf(b.toUpperCase());
                                    }).map(item => item?.toUpperCase())}
                                    circle 
                                    />
                               }
                                <Warning text="Please choose a size before adding to the cart." isVisible={showSizeWarning}/>
                            </Markup.Screen.Name.SpecItemSize>
                        }
                        <Markup.Screen.Name.SpecItem>
                            <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>Quantity</Markup.Screen.Name.SpecItemText>
                            <Count value={builder.membersData.currentMember.data.quantity} setValue={item => builder.membersData.updateMember({ data: { quantity: item } })} max={10} min={1} />
                        </Markup.Screen.Name.SpecItem>
                    </>
                }

                {builder?.options?.sleeve &&
                    <Markup.Screen.Name.SpecItem>
                        <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>Sleeve</Markup.Screen.Name.SpecItemText>
                        <Toggle active={builder.membersData.currentMember.data.sleeve} setActive={item => builder.membersData.updateMember({ data: { sleeve: item } })} items={['Short', 'Long']} small />
                    </Markup.Screen.Name.SpecItem>
                }

                {builder?.options?.sex &&
                    <Markup.Screen.Name.SpecItem>
                        <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>Fit</Markup.Screen.Name.SpecItemText>
                        <Toggle
                            active={builder.membersData.currentMember.data.sex}
                            setActive={item => builder.membersData.updateMember({ data: { sex: item } })}
                            items={ [...(builder.options?.gender ?? ['male', 'female'])].sort((a, b) => {
                                const order = ['male', 'female', 'youth'];
                                return order.indexOf(a.toLowerCase()) - order.indexOf(b.toLowerCase());
                            }).map(item => item.length > 0 ? String(item)[0].toUpperCase() + String(item).slice(1) : '')}
                            small
                        />
                    </Markup.Screen.Name.SpecItem>
                }
            </Markup.Screen.Name.SpecContainer>
            {isMobile && <Warning text="Please choose a size before adding to the cart." isVisible={showSizeWarning}/>}
            {!(typeof (window as any).builderSaveDesign === 'function' && typeof (window as any).builderAddToCartBatch === 'function') && (
                <>
                    <Markup.Screen.Name.AddCartItem themeColor={builder.membersData.colorTheme} disable={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}
                                                    data-keyBtn={builder.membersData.currentMember.removeKey} onClick={handleAddToCart}
                    >{builder.membersData.members[builder.membersData.currentMemberIndex].messageBtn}</Markup.Screen.Name.AddCartItem>
                    <Markup.Screen.Name.Message>{builder.membersData.members[builder.membersData.currentMemberIndex].messageUnBtn}</Markup.Screen.Name.Message>
                </>
            )}
            <Markup.Screen.Name.SpecItemPrice>
                <Markup.Screen.Name.SpecItemTextSummary themeColor={builder.membersData.colorTheme}>Summary</Markup.Screen.Name.SpecItemTextSummary>
            </Markup.Screen.Name.SpecItemPrice>
            <Markup.Screen.Name.SpecItemPriceTwoRows>
                <Markup.Screen.Name.SpecItemTextTotal themeColor={builder.membersData.colorTheme}>Quantity</Markup.Screen.Name.SpecItemTextTotal>
                <Markup.Screen.Name.SpecItemTextTotalPr themeColor={builder.membersData.colorTheme}>{builder.membersData.totalSum()}</Markup.Screen.Name.SpecItemTextTotalPr>
            </Markup.Screen.Name.SpecItemPriceTwoRows>
            <Markup.Screen.Name.SpecItemPriceTwoRows>
                <Markup.Screen.Name.SpecItemTextTotal themeColor={builder.membersData.colorTheme}>Cost per item</Markup.Screen.Name.SpecItemTextTotal>
                <Markup.Screen.Name.SpecItemTextTotalPr themeColor={builder.membersData.colorTheme}>{builder.manifest.price}</Markup.Screen.Name.SpecItemTextTotalPr>
            </Markup.Screen.Name.SpecItemPriceTwoRows>
            <Markup.Screen.Name.SpecItemPriceTwoRows>
                <Markup.Screen.Name.SpecItemTextTotalPrice themeColor={builder.membersData.colorTheme}>Total</Markup.Screen.Name.SpecItemTextTotalPrice>
                <Markup.Screen.Name.SpecItemTextTotalPriceTo themeColor={builder.membersData.colorTheme}>{builder.manifest.currency+builder.manifest.peritemPrice * builder.membersData.totalSum()}</Markup.Screen.Name.SpecItemTextTotalPriceTo>
            </Markup.Screen.Name.SpecItemPriceTwoRows>

            {!isMobile && <SaveButtons/>}
        </>
    );
}

export default React.memo(NameSpec);
